/**
 * Liste des rôles assignables via `POST /v1/users/:userId/roles` côté UI.
 *
 * Set provisoire — à confirmer avec Yohan jeudi (cf. plan §9 question 3).
 * Couvre les rôles connus du JWT actuel (`Account_Admin`, `Account_Owner`,
 * `Passenger`) + la permission tech `EXTRANET_ADMIN` mentionnée dans la doc.
 *
 * Le `UserRolesModal` présente une checkbox par rôle de cette liste, mais
 * **conserve** les rôles inconnus déjà assignés à l'utilisateur (pour ne pas
 * les écraser involontairement, cf. warning Yohan).
 */
export const ASSIGNABLE_ROLES = ['Account_Admin', 'Account_Owner', 'EXTRANET_ADMIN', 'Passenger'] as const;

export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number];

interface RoleVisualTokens {
  bg: string;
  text: string;
}

/**
 * Couleurs par rôle connu. Tout rôle non listé tombe sur le fallback neutre.
 */
export const ROLE_COLORS: Record<string, RoleVisualTokens> = {
  Account_Admin: { bg: 'bg-red-50', text: 'text-red-700' },
  Account_Owner: { bg: 'bg-blue-50', text: 'text-blue-700' },
  EXTRANET_ADMIN: { bg: 'bg-violet-50', text: 'text-violet-700' },
  Passenger: { bg: 'bg-zinc-100', text: 'text-zinc-700' },
};

export const ROLE_FALLBACK_COLOR: RoleVisualTokens = {
  bg: 'bg-zinc-100',
  text: 'text-zinc-700',
};

export const getRoleColor = (role: string): RoleVisualTokens => ROLE_COLORS[role] ?? ROLE_FALLBACK_COLOR;
